import { render } from "./contract_quo.vue?vue&type=template&id=312ed072&scoped=true"
import script from "./contract_quo.vue?vue&type=script&lang=js"
export * from "./contract_quo.vue?vue&type=script&lang=js"

import "./contract_quo.vue?vue&type=style&index=0&id=312ed072&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312ed072"]])

export default __exports__